import { MediaMatcher } from "@angular/cdk/layout";
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  ViewChild,
} from "@angular/core";
import { MatSidenav } from "@angular/material";
import { Alert } from "../../class/Alert";
import { globalConst } from "../../helpers/constants";
import { userType } from "../../helpers/enum";
import { Helper } from "../../helpers/helper";
import { User } from "../../models/user.model";
import { AuthService } from "../../services/auth.service";
import { NavService } from "../../services/nav-menu.service";
import { NavMenuItem } from "../nav-menu-list-item/nav-menu-list-item.component";

export interface MenuItem {
  displayName: string;
  route?: string;
  children?: MenuItem[];
}
@Component({
  selector: "app-nav-menu",
  templateUrl: "./nav-menu.component.html",
  styleUrls: ["./nav-menu.component.scss"],
})
export class NavMenuComponent implements AfterViewInit, OnDestroy {
  @ViewChild("appDrawer", null) public appDrawer: MatSidenav;
  mobileQuery: MediaQueryList;
  logo = "";
  logoA = "";
  navItems: NavMenuItem[] = [
    {
      displayName: "Home",
      route: "/home",
    },
  ];

  // tslint:disable-next-line: variable-name
  private _mobileQueryListener: () => void;
  public userLogged: User = {};
  constructor(
    private navService: NavService,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private authService: AuthService
  ) {
    this.mobileQuery = media.matchMedia("(min-width: 959px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    // tslint:disable-next-line: deprecation
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.logo = Helper.getLogo();
    this.logoA = Helper.getLogoA();
    this.loadNavItens();
    this.userLogged = this.authService.getUserLogged();
  }

  ngAfterViewInit() {
    this.navService.setSidenav(this.appDrawer);
  }

  ngOnDestroy(): void {
    // tslint:disable-next-line: deprecation
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  toggleSidenav() {
    this.navService.toggle();
  }

  private loadAdminMenu() {
    this.navItems.push(
      {
        displayName: "Cadastros",
        route: "",
        children: [
          {
            displayName: "Usuários",
            route: "",
            children: [
              {
                displayName: "Listagem",
                route: "/user/list",
              },
              {
                displayName: "Novo Usuário",
                route: "/user/add",
              },
            ],
          },
          {
            displayName: "Ambientes Umov.me",
            route: "/umovme-environment/list",
          },
        ],
      },
      {
        displayName: "Atualizações",
        route: "",
        children: [
          {
            displayName: "Banco de Dados",
            route: "/updateDatabase/list",
          },
        ],
      },
      {
        displayName: "Relatórios",
        route: "",
        children: [
          {
            displayName: "Solicitações de Serviço",
            route: "/report/service-request",
          },
          {
            displayName: "Inventário",
            route: "/report/inventory",
          },
          {
            displayName: "Relatório de Acesso",
            route: "/report/access",
          },
        ],
      }
    );
  }

  private loadTechnicalMenu() {
    this.navItems.push({
      displayName: "Relatórios",
      route: "",
      children: [
        {
          displayName: "Inventário",
          route: "/report/inventory",
        },
      ],
    });
  }

  private loadServiceRequestMenu() {
    const options = {
      displayName: "Solicitação de Serviço",
      route: "",
      children: [
        {
          displayName: "Consulta",
          route: "/serviceRequest/list",
        },
        {
          displayName: "Abrir Nova S.S.",
          route: "/serviceRequest/details",
        },
      ],
    };

    if (this.authService.getUserLogged().type === userType.admin) {
      options.children.push({
        displayName: "Associar Técnico",
        route: "/serviceRequest/add-agent",
      });
    }

    this.navItems.push(options);
  }

  private loadDashboardMenu() {
    const options = {
      displayName: "Dashboard",
      route: "/dashboard",
      children: [],
    };

    if (this.authService.getUserLogged().type === userType.admin)
      this.navItems.push(options);
  }

  loadNavItens() {
    this.loadDashboardMenu();
    this.loadServiceRequestMenu();

    if (this.authService.getUserLogged().type === userType.admin) {
      this.loadAdminMenu();
    } else if (this.authService.getUserLogged().type === userType.technical) {
      this.loadTechnicalMenu();
    }
  }

  logout() {
    this.authService.logout();
  }

  about() {
    Alert.info(
      "",
      "",
      `<h2>Versão: ${globalConst.version}<br></h2>
      <h3>Notas da Versão</h3>
      <ol>
        <li>Relatório de Inventário</li>
      </ol>
      `
    );
  }
}
